import { AbstractControl } from '@angular/forms';
import { environment } from 'src/environments/environment';

export function serieValidator(control: AbstractControl) {
  let serie: string = control && control.value || '';
  serie = serie.replace(/\./g, '');

  if (serie === null || serie.trim() === '') { return null; }

  const numeroSeriePatternCombinado = new RegExp(combinePatterns(environment.fieldValidations.numeroSeriePatterns));

  // valor minimo de largo desde que se empieza a validar
  if (serie.length <= 6) {
    return { serieLength: true };
  }

  //Si cumple criterios de pattern
  if (!serie.match(numeroSeriePatternCombinado)) {
    return { serieLength: true };
  }

  return null;
}

function combinePatterns(patterns: Array<{ [key: number]: string }>): RegExp {
  // Extraer y limpiar las expresiones regulares
  const combinedSource = patterns
    .map((item) => {
      const key = Object.keys(item)[0]; // Obtener la clave del objeto
      const pattern = item[key];       // Obtener el valor del patrón
      return pattern.slice(1, -1);     // Eliminar las barras inclinadas "/"
    })
    .join('|'); // Unir las expresiones regulares con el operador OR "|"

  // Crear una nueva expresión regular combinada
  return new RegExp(combinedSource);
}
